import { Button, IconButton, tooltipClasses } from "@mui/material";
import { GridApiCommon, GridInitialState } from "@mui/x-data-grid";
import { t } from "i18next";
import { enqueueSnackbar } from "notistack";
import { MutableRefObject, useCallback, useEffect } from "react";
import { TbTableOptions } from "react-icons/tb";

import { LocaleStorageKeys } from "@/constants";
import { softColors } from "@/constants/colors";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";
import { getGridOptions } from "@/utils/grid";

interface CommonGridSettingsButtonProps {
    apiRef: MutableRefObject<GridApiCommon>;
    storageKey: LocaleStorageKeys;
    defaultOptions: GridInitialState;
    newColumnNames?: string[];
}

function CommonGridSettingsButton({
    apiRef,
    storageKey,
    defaultOptions,
    newColumnNames,
}: CommonGridSettingsButtonProps) {
    useEffect(() => {
        if (apiRef.current) {
            const initialState = getGridOptions(storageKey, newColumnNames) || defaultOptions;

            apiRef.current.restoreState(initialState);
        }
    }, [apiRef, defaultOptions, storageKey]);

    const saveGridOptions = useCallback(() => {
        const state = apiRef.current.exportState();
        if (state) {
            localStorage.setItem(storageKey, JSON.stringify({ state }));
            enqueueSnackbar(t("snackbars.gridOptionsSaved"), {
                variant: "success",
            });
        }
    }, [apiRef, storageKey]);

    const resetGridOptions = useCallback(() => {
        localStorage.removeItem(storageKey);

        apiRef.current.restoreState(defaultOptions);
        enqueueSnackbar(t("snackbars.gridOptionsReset"), {
            variant: "success",
        });
    }, [apiRef, storageKey, defaultOptions]);

    return (
        <NoMaxWidthTooltip
            arrow
            sx={{
                [`& .${tooltipClasses.tooltip}`]: {
                    backgroundColor: "white",
                    border: "none",
                    padding: "0px !important",
                    fontSize: 12,
                    maxWidth: "300px !important",
                },
            }}
            title={
                <HotelStatusTooltip
                    status={{
                        ...softColors.brown,
                        component: () => TbTableOptions,
                        tooltip: {
                            title: t("tooltips.gridOptions"),
                            description: t("tooltips.gridOptionsDesc"),
                        },
                    }}
                >
                    <Button onClick={resetGridOptions}> Varsayılan Ayarlara Dön</Button>
                </HotelStatusTooltip>
            }
        >
            <div>
                <IconButton color="secondary" onClick={saveGridOptions}>
                    <TbTableOptions />
                </IconButton>
            </div>
        </NoMaxWidthTooltip>
    );
}

export default CommonGridSettingsButton;
